import { cn } from "@/lib/helpers/cn";
import React from "react";
import { ModalOverlay as AriaOverlay, type ModalOverlayProps } from "react-aria-components";

export function ModalOverlay2(props: ModalOverlayProps) {
  return (
    <AriaOverlay
      {...props}
      className={({ isEntering, isExiting }) =>
        cn(
          "tw:fixed tw:inset-0 tw:min-h-full tw:w-full tw:z-overlay",
          "tw:flex tw:items-center tw:justify-center",
          "tw:bg-fill-black/20 tw:backdrop-blur-xs",
          isEntering && "tw:duration-150 tw:ease-in-out tw:animate-in tw:fade-in",
          isExiting && "tw:duration-150 tw:ease-in-out tw:animate-out tw:fade-out",
        )
      }
    />
  );
}
